import { http } from '../../config/axios'

 const findConsultaLote = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/consultalote/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findConsultaLote', error)
      throw Error(error.response.data)
    })
}

export default findConsultaLote;
